var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.9375 0H1.0625C0.476 0 0 0.476 0 1.0625V1.66706L8.5 5.26681L17 1.666V1.0625C17 0.476 16.524 0 15.9375 0Z","fill":"#FF0000","key":0}),React.createElement("path",{"d":"M8.70719 6.86386C8.64131 6.89255 8.57012 6.90636 8.5 6.90636C8.42988 6.90636 8.35869 6.89255 8.29281 6.86386L0 3.35229V11.1564C0 11.7429 0.476 12.2189 1.0625 12.2189H15.9375C16.524 12.2189 17 11.7429 17 11.1564V3.35229L8.70719 6.86386Z","fill":"#FF0000","key":1})]);
}

EmailInline.defaultProps = {"width":"17","height":"13","viewBox":"0 0 17 13","fill":"none"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
